import React, { Component } from "react";
import { Button, Tag, message } from "antd";
import fetchHandler from "@/fetch/fetchHandler";
import functionTool from "@/utils/Tool";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import EquipmentListModal from "./equipmentListModal";
import EquipmentListModalDel from "./equipmentListModalDel";
import EquipmentListModalDel2 from "./equipmentListModalDel2";
@connect((state) => state)
class AddEquipment extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.addEquipment;
    // const value = props.value;
    this.state = {
      // tags: [],
    };
  }

  checkTags(tags) {
    const noNameTags = tags.filter((tag) => !tag.name);
    if (noNameTags.length > 0) {
      const idsArr = noNameTags.map((tag) => {
        return tag.key;
      });
      fetchHandler("", {
        stubGroupIds: idsArr.join(","),
      }).then((res) => {
        if (res && res.code === "success") {
          if (functionTool.notNull(res.data)) {
            const resData = res.data;
            resData.filter((item) => !item.id);
            resData.map((item) => {
              tags.map((t) => {
                if (t.key === item.id) {
                  t.name = item.name;
                }
                return true;
              });
              return true;
            });
            this.triggerChange(tags);
          }
        }
      });
    }
  }

  handleTagClose = (removedTag) => {
    const tags = this.props.value.filter((tag) => tag.key !== removedTag.key);
    /* this.setState({
         tags
         }); */
    this.triggerChange(tags);
  };

  triggerChange = (tags) => {
    const onChange = this.props.onChange;
    if (onChange) {
      onChange(tags);
    }
  };

  handleAddBtnClick = () => {
    this.setState({
      visible: true,
    });
  };

  handleDeleteBtnClick = () => {
    this.setState({
      deleteStationVisible: true,
    });
  };

  handleDeleteBtnClick2 = () => {
    this.setState({
      deleteStationVisible2: true,
    });
  };

  closeModal = () => {
    this.setState({
      visible: false,
    });
  };

  closeModalEx = () => {
    this.setState({
      deleteStationVisible: false,
    });
  };

  closeModalEx2 = () => {
    this.setState({
      deleteStationVisible2: false,
    });
  };

  addStation = (stations) => {
    if (stations.length === 0) {
      message.error(this.internationalization.msg1);
      return;
    }
    let tags = this.props.value;

    // 过滤已存在的
    stations = stations.filter(
      (item) => !tags.map((i) => i.key).includes(item.key),
    );
    if (stations.length === 0) {
      message.error(this.internationalization.msg2);
      return;
    }
    tags = [...tags, ...stations];
    /* this.setState({
         tags
         }) */
    message.success(this.internationalization.msg3);
    this.setState({
      visible: true,
    });
    this.triggerChange(tags);
  };

  deleteStation = (station) => {
    if (station.length === 0) {
      message.error(this.internationalization.msg4);
      return;
    }
    const tags = this.props.value;
    const flag = tags.map((i) => i.key).includes(station[0].key);
    if (!flag) {
      message.error(this.internationalization.msg5);
      return;
    }
    console.log("tags1------", this.props.value);
    // tags.splice(item=>tags.findIndex(item=>item.key === station[0].key), 1);
    // tags.filter(item=>item.key===station[0].key);
    tags.map((item, index) => {
      if (item.key === station[0].key) {
        tags.splice(index, 1);
      }
      return true;
    });
    console.log("tags2------", tags);
    message.success(this.internationalization.msg6);
    this.triggerChange(tags);
  };

  addCurrentStubGroup = (stations) => {
    if (stations.length === 0) {
      message.error(this.internationalization.msg7);
      return;
    }
    const tags = [...stations];
    message.success(this.internationalization.msg8);
    this.triggerChange(tags);
    this.setState({
      visible: false,
    });
  };

  render() {
    if (!this.props.isRender) {
      this.checkTags(this.props.value);
    }
    const tags = this.props.value.length > 100
      ? this.props.value.slice(0, 100)
      : this.props.value;
    return (
      <div style={this.props.style}>
        <Button type="primary" onClick={this.handleAddBtnClick}>
          {this.internationalization.msg9}
        </Button>
        {this.props.fromMember && (
          <Button type="primary" onClick={this.handleDeleteBtnClick2}>
            {this.internationalization.btn1}
          </Button>
        )}
        <div style={this.props.tagStyle}>
          {tags
            && tags.map((tag) => {
              return (
                <Tag
                  key={tag.key}
                  closable
                  onClose={() => {
                    this.handleTagClose(tag);
                  }}
                >
                  {tag.key}
                </Tag>
              );
            })}
        </div>
        {this.props.value.length > 100 && (
          <div style={{ color: "red" }}>*{this.internationalization.msg10}</div>
        )}
        {this.state.visible && (
          <EquipmentListModal
            {...this.props}
            visible={this.state.visible}
            cancel={this.closeModal}
            selectedStations={this.props.value}
            add={this.addStation}
            addCurrent={this.addCurrentStubGroup}
          />
        )}
        {this.state.deleteStationVisible && (
          <EquipmentListModalDel
            {...this.props}
            visible={this.state.deleteStationVisible}
            cancel={this.closeModalEx}
            selectedStations={this.props.value}
            delete={this.deleteStation}
          />
        )}
        {this.state.deleteStationVisible2 && (
          <EquipmentListModalDel2
            {...this.props}
            visible={this.state.deleteStationVisible2}
            cancel={this.closeModalEx2}
            selectedStations={this.props.value}
            delete={this.deleteStation}
          />
        )}
      </div>
    );
  }
}

export default injectIntl(AddEquipment);



// WEBPACK FOOTER //
// ./src/AntD/pages/onlineOperations/taskManagement/addEquipment.js